import { useCallback } from 'react';

import ROUTES from '@/common/routes';
import { useHistory } from '@/modules/core/hooks';
import { USERNAME_QUERY_KEY } from '@/modules/user/components/SignIn/signIn.types';

const useNavigateToPasswordResetLinkSent = () => {
  const { push } = useHistory();

  const navigateToPasswordResetLinkSent = useCallback((username: string) => {
    push(`${ROUTES.FORGOT_PASSWORD_LINK_SENT}?${USERNAME_QUERY_KEY}=${username}`);
  }, [push]);

  return { navigateToPasswordResetLinkSent };
};

export default useNavigateToPasswordResetLinkSent;
